import React from 'react'
import {connect} from 'react-redux'
import {Switch, Route, Router, Link, Redirect} from 'react-router-dom'
import history from 'common/history'
import Home from 'page/home';
import Course from 'page/course';
import CourseProject from 'page/course_project';
import CourseExper from 'page/course_experiment';
import CourseLive from 'page/course_live';
import CourseLiveInfo from 'page/course_live_info';
import CourseExperInfo from 'page/course_experiment_info';
import LabRoom from 'page/labroom';
import LabRoomVideo from 'page/labroom_video';
import LabRoomExper from 'page/labroom_experiment';
import Personal from 'page/personal';
import Identify from 'page/identify';
import * as util from 'common/util'
import { actionCreators } from 'page/home/store'

class App extends React.Component {
	componentWillMount () {
		this.checkLogin()
	}
	async checkLogin () {
		let token = util.getCookie('_token')
		// userinfo {"user_name":"admin","user_id":39,"tenant":95,"realname":"赵光明","verifyphone":0}
		// let token = "7df4e1ba07ec7f9d632e2db9c6ca8bce29dc8d31f9d183d82a4d5097d7170366a%3A2%3A%7Bi%3A0%3Bs%3A6%3A%22_token%22%3Bi%3A1%3Bs%3A1099%3A%22eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhY2NvdW50IjoiYWRtaW4iLCJlbWFpbCI6InRlc3RAYWx0b3JvbXV0dWFsLmNvbSIsImV4cCI6MTU5MDA1MjM4OSwibG9naW5UeXBlIjoiZGVmYXVsdCIsIm1yb2xlcyI6W3siY21jcm9sZSI6IiIsImNvZGUiOiJhZG1pbiIsImNyZWF0ZWRfYXQiOiIyMDE4LTAzLTE3VDEwOjQ2OjQ3KzA4OjAwIiwiZGVzY3JpcHRpb24iOiIiLCJkaXNwbGF5X25hbWUiOiLns7vnu5_nrqHnkIblkZgiLCJpZCI6MTIsImlzZGVmYXVsdCI6IjEifV0sIm1zdHJ1Y3R1cmVzIjpbeyJjb2RlIjoiIiwiY3JlYXRlZF9hdCI6IjIwMTgtMDgtMTZUMTA6NDk6MTErMDg6MDAiLCJkaXNwbGF5X25hbWUiOiIyMDA457qnMuePrSIsImlkIjoxMjgsImxldmVsIjozLCJwYXJlbnQiOnsiY29kZSI6IiIsImNyZWF0ZWRfYXQiOiIyMDE4LTA4LTE2VDEwOjE5OjQ0KzA4OjAwIiwiZGlzcGxheV9uYW1lIjoi6L2v5Lu25bel56iLIiwiaWQiOjEyNywibGV2ZWwiOjIsInBhcmVudCI6eyJjb2RlIjoiIiwiY3JlYXRlZF9hdCI6IjIwMTgtMDMtMTdUMTE6MjU6NDYrMDg6MDAiLCJkaXNwbGF5X25hbWUiOiLorqHnrpfmnLrlrabpmaIiLCJpZCI6MzEsImxldmVsIjoxLCJwY29kZSI6IiIsInBpZCI6MH0sInBjb2RlIjoiIiwicGlkIjozMX0sInBjb2RlIjoiIiwicGlkIjoxMjd9XSwicGFzc3dvcmQiOiIxNTAwYTdhYjhkMTMxZmNmN2UyMzQ3NzEyZjgyYzEzOSIsInBob25lIjoiNTU1LTU1NS01NTU1IiwicmVhbG5hbWUiOiLotbXlhYnmmI4iLCJzdWIiOjM5LCJ0ZW5hbnRfaWQiOjIxfQ.iVYAcZB-5_ASJDXcA6sPAB6S4Xxea-_ELb0wmdmUeTc%22%3B%7D"
        const pattern=/{i:\d+;s:\d+:"_token";i:\d+;s:\d+:"(.+?)";}/
        token = pattern.exec(decodeURIComponent(token))
        token = token?`${token[1]}`: ''
        let tenantCode = util.getQueryParam('tenant_code')
        if (!token) {
        	return (window.location.href = `${window.AppConfig.loginUrl}?tenant_code=${tenantCode?tenantCode:95}`)
        } else if (token && !localStorage.getItem('tenant_code')){
            localStorage.setItem("tenant_code", tenantCode?tenantCode:95)
		} else if(token && localStorage.getItem(('tenant_code'))) {
            if (tenantCode && localStorage.getItem('tenant_code') !== tenantCode) {//判断租户id是否一致
                localStorage.removeItem('tenant_code');
            	// 不一致则需要重新登陆
                window.location.href = `${window.AppConfig.loginUrl}?tenant_code=${tenantCode?tenantCode:95}`
            }
		}
		await this.props.setUserInfo()
	}

	render () {
		return (
			<Router history={history}>
	            <Switch>
					<Route  exact path='/' component={Home}/>
					<Route  exact path='/course/project' component={Course}/>
					<Route  exact path='/course/live' component={Course}/>
					<Route  exact path='/course/experiment' component={Course}/>
					<Route  exact path='/courseproject/:id' component={CourseProject}/>
					<Route  exact path='/courselive/:id' component={CourseLive}/>
					<Route  exact path='/courseexper/:id' component={CourseExper}/>
					<Route  exact path='/courseliveinfo/:id' component={CourseLiveInfo}/>
					<Route  exact path='/courseexperinfo/:id' component={CourseExperInfo}/>
					<Route  exact path='/labroom/:id' component={LabRoom}/>
					<Route  exact path='/labroomvideo/:id' component={LabRoomVideo}/>
					<Route  exact path='/labroomexper/:id' component={LabRoomExper}/>
					<Route  exact path='/personal' component={Personal}/>
					<Route  exact path='/identify/:sid/:courseid/:location'  component={Identify}/>
	              </Switch>
	          </Router>
	     )
	}
}

const mapState = (state) => ({
})

const mapDispatch = (dispatch) => ({
	setUserInfo(){
        dispatch(actionCreators.setUserInfo())
    }
})

export default connect(mapState, mapDispatch)(App)
